// This file is part of Indico.UN.
// Copyright (C) 2019 - 2026 United Nations. All rights reserved.

import {registerPluginComponent} from 'indico/utils/plugins';

import SignupPasswordChecklist from '../../modules/auth/client/signup';

registerPluginComponent('un', 'signup-form-after-password', SignupPasswordChecklist);
